var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4Cars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 50,
    viewBox: "50 100 540 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .greyColor {\n      fill: #eee !important;\n    }\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.4633 190.211C70.5467 193.029 80.7478 192.795 85.713 192.325C85.713 170.055 102.414 164.958 110.764 165.193C130.806 168.294 134.462 184.573 133.785 192.325H238.053C238.053 183.281 242.86 165.193 262.089 165.193C281.318 165.193 286.351 183.281 286.463 192.325C304.609 195.426 306.888 183.751 305.76 177.525C301.156 157.793 284.884 153.565 277.323 153.917C272.448 153.071 254.528 147.927 246.178 145.46C194.45 97.5389 117.648 120.795 85.713 138.413H72.1716C67.0259 138.413 65.2881 143.111 65.0624 145.46V158.498L61 165.193V179.287C61 183.516 66.6422 188.331 69.4633 190.211Z",
    stroke: "#5f5f5f",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.733 147.575H161.206L157.482 125.376C142.248 122.909 117.874 135.242 108.733 140.175C101.421 144.121 105.687 146.752 108.733 147.575Z",
    stroke: "#5f5f5f",
    strokeWidth: 5,
    className: "greyColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168.654 147.575L165.268 125.376C199.46 122.557 215.71 135.947 224.173 140.175C230.944 143.558 228.349 146.517 226.204 147.575H168.654Z",
    stroke: "#5f5f5f",
    strokeWidth: 5,
    className: "greyColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.545 190.563C126.545 200.565 118.78 208.5 109.41 208.5C100.04 208.5 92.2754 200.565 92.2754 190.563C92.2754 180.561 100.04 172.626 109.41 172.626C118.78 172.626 126.545 180.561 126.545 190.563Z",
    stroke: "#5f5f5f",
    strokeWidth: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M278.886 190.563C278.886 200.565 271.121 208.5 261.751 208.5C252.381 208.5 244.616 200.565 244.616 190.563C244.616 180.561 252.381 172.626 261.751 172.626C271.121 172.626 278.886 180.561 278.886 190.563Z",
    stroke: "#5f5f5f",
    strokeWidth: 5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M341.463 190.211C342.547 193.029 352.748 192.795 357.713 192.325C357.713 170.055 374.414 164.958 382.764 165.193C402.806 168.294 406.462 184.573 405.785 192.325H510.053C510.053 183.281 514.86 165.193 534.089 165.193C553.318 165.193 558.351 183.281 558.463 192.325C576.609 195.426 578.888 183.751 577.76 177.525C573.156 157.793 556.884 153.565 549.323 153.917C544.448 153.071 526.528 147.927 518.178 145.46C466.45 97.5389 389.648 120.795 357.713 138.413H344.172C339.026 138.413 337.288 143.111 337.062 145.46V158.498L333 165.193V179.287C333 183.516 338.642 188.331 341.463 190.211Z",
    stroke: "#5f5f5f",
    strokeWidth: 5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M380.733 147.575H433.206L429.482 125.376C414.248 122.909 389.874 135.242 380.733 140.175C373.421 144.121 377.687 146.752 380.733 147.575Z",
    stroke: "#5f5f5f",
    strokeWidth: 5,
    className: "greyColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M440.654 147.575L437.268 125.376C471.46 122.557 487.71 135.947 496.173 140.175C502.944 143.558 500.349 146.517 498.204 147.575H440.654Z",
    stroke: "#5f5f5f",
    strokeWidth: 5,
    className: "greyColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M398.545 190.563C398.545 200.565 390.78 208.5 381.41 208.5C372.04 208.5 364.275 200.565 364.275 190.563C364.275 180.561 372.04 172.626 381.41 172.626C390.78 172.626 398.545 180.561 398.545 190.563Z",
    stroke: "#5f5f5f",
    strokeWidth: 5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M550.886 190.563C550.886 200.565 543.121 208.5 533.751 208.5C524.381 208.5 516.616 200.565 516.616 190.563C516.616 180.561 524.381 172.626 533.751 172.626C543.121 172.626 550.886 180.561 550.886 190.563Z",
    stroke: "#5f5f5f",
    strokeWidth: 5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4633 299.211C70.5467 302.029 80.7478 301.795 85.713 301.325C85.713 279.055 102.414 273.958 110.764 274.193C130.806 277.294 134.462 293.573 133.785 301.325H238.053C238.053 292.281 242.86 274.193 262.089 274.193C281.318 274.193 286.351 292.281 286.463 301.325C304.609 304.426 306.888 292.751 305.76 286.525C301.156 266.793 284.884 262.565 277.323 262.917C272.448 262.071 254.528 256.927 246.178 254.46C194.45 206.539 117.648 229.795 85.713 247.413H72.1716C67.0259 247.413 65.2881 252.111 65.0624 254.46V267.498L61 274.193V288.287C61 292.516 66.6422 297.331 69.4633 299.211Z",
    stroke: "#5f5f5f",
    strokeWidth: 5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.733 256.575H161.206L157.482 234.376C142.248 231.909 117.874 244.242 108.733 249.175C101.421 253.121 105.687 255.752 108.733 256.575Z",
    stroke: "#5f5f5f",
    strokeWidth: 5,
    className: "greyColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M168.654 256.575L165.268 234.376C199.46 231.557 215.71 244.947 224.173 249.175C230.944 252.558 228.349 255.517 226.204 256.575H168.654Z",
    stroke: "#5f5f5f",
    strokeWidth: 5,
    className: "greyColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M126.545 299.563C126.545 309.565 118.78 317.5 109.41 317.5C100.04 317.5 92.2754 309.565 92.2754 299.563C92.2754 289.561 100.04 281.626 109.41 281.626C118.78 281.626 126.545 289.561 126.545 299.563Z",
    stroke: "#5f5f5f",
    strokeWidth: 5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M278.886 299.563C278.886 309.565 271.121 317.5 261.751 317.5C252.381 317.5 244.616 309.565 244.616 299.563C244.616 289.561 252.381 281.626 261.751 281.626C271.121 281.626 278.886 289.561 278.886 299.563Z",
    stroke: "#5f5f5f",
    strokeWidth: 5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M341.463 299.211C342.547 302.029 352.748 301.795 357.713 301.325C357.713 279.055 374.414 273.958 382.764 274.193C402.806 277.294 406.462 293.573 405.785 301.325H510.053C510.053 292.281 514.86 274.193 534.089 274.193C553.318 274.193 558.351 292.281 558.463 301.325C576.609 304.426 578.888 292.751 577.76 286.525C573.156 266.793 556.884 262.565 549.323 262.917C544.448 262.071 526.528 256.927 518.178 254.46C466.45 206.539 389.648 229.795 357.713 247.413H344.172C339.026 247.413 337.288 252.111 337.062 254.46V267.498L333 274.193V288.287C333 292.516 338.642 297.331 341.463 299.211Z",
    stroke: "#5f5f5f",
    strokeWidth: 5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M380.733 256.575H433.206L429.482 234.376C414.248 231.909 389.874 244.242 380.733 249.175C373.421 253.121 377.687 255.752 380.733 256.575Z",
    stroke: "#5f5f5f",
    strokeWidth: 5,
    className: "greyColor"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M440.654 256.575L437.268 234.376C471.46 231.557 487.71 244.947 496.173 249.175C502.944 252.558 500.349 255.517 498.204 256.575H440.654Z",
    stroke: "#5f5f5f",
    strokeWidth: 5,
    className: "greyColor"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M398.545 299.563C398.545 309.565 390.78 317.5 381.41 317.5C372.04 317.5 364.275 309.565 364.275 299.563C364.275 289.561 372.04 281.626 381.41 281.626C390.78 281.626 398.545 289.561 398.545 299.563Z",
    stroke: "#5f5f5f",
    strokeWidth: 5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M550.886 299.563C550.886 309.565 543.121 317.5 533.751 317.5C524.381 317.5 516.616 309.565 516.616 299.563C516.616 289.561 524.381 281.626 533.751 281.626C543.121 281.626 550.886 289.561 550.886 299.563Z",
    stroke: "#5f5f5f",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Cars);
export default __webpack_public_path__ + "static/media/4-cars.77c0f161bc6b1633f1e528ce48720701.svg";
export { ForwardRef as ReactComponent };